export default [  
  {
    path: '/parameters',
    name: 'parameters',
    component: () => import('@/views/modules/parameters/edit'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Parameters',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Parameters' }
      ]
    },
  },

 
]